export default __webpack_public_path__ + "static/media/1.94475309.jpeg";